module.exports = __webpack_public_path__ + "static/media/The-Grand.db5b26de.png";